import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendSelectClickSoundCommand } from '../../../helpers/web_to_client'

import styles from './TableRow.css'

const propTypes = {
    children: PropTypes.node.isRequired,
    isOwn: PropTypes.bool,
    isHoverable: PropTypes.bool,
    isActive: PropTypes.bool,
    needPlayHoverSound: PropTypes.bool,
    onClick:  PropTypes.func,
}

const TableRow = (props) => {
    const classNameBase = classNames(styles.tr, {
        [styles.tr__isHoverable]: props.isHoverable,
        [styles.tr__isActive]: props.isActive,
    })

    const conditionOwn = props.isOwn ? (
        <div className={classNames(styles.trCondition, styles.trCondition__own)} />
    ) : null

    return (
        <div
            className={classNameBase}
            onClick={props.onClick}
            onMouseDown={props.onClick ? sendSelectClickSoundCommand : null}
            onMouseEnter={props.needPlayHoverSound ? sendHoverSoundCommand : null}
        >
            {conditionOwn}
            {props.children}
        </div>
    )
}

TableRow.propTypes = propTypes

export default TableRow



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Table/TableRow/TableRow.jsx